import { Box, FormControlLabel, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { StyledInputLabel } from '../Dropdown/style';
import IOSSwitch from './style'; // Adjust the import path as needed

const SwitchToggle = ({
  name = '',
  label,
  required,
  disabled = false,
  defaultChecked = false,
  onChangeValue = () => {},
  objData = {},
  customStyle = { marginRight: 2 }
}) => {
  const { control } = useFormContext();
  let customStyles = customStyle;

  return (
    <Box>
      {/* Title above the switch */}
      <StyledInputLabel htmlFor={name}>
        {label}
        {required && <span className="required">*</span>}
      </StyledInputLabel>

      {/* Switch and labels below the title */}
      <Box display="flex" flexDirection="column" alignItems="start" mt={2}>
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <>
              <FormControlLabel
                className="active-switch"
                labelPlacement="start"
                control={
                  <Box display="flex" alignItems="center">
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      fontWeight="bold"
                      fontSize="14px"
                      sx={customStyles} // Space between label and switch
                      className={disabled ? 'switch-label-disabled' : ''}>
                      No
                    </Typography>
                    <IOSSwitch
                      checked={value ?? defaultChecked}
                      disabled={disabled}
                      defaultChecked={defaultChecked}
                      onChange={(event, checked) => {
                        onChange(checked);
                        onChangeValue(objData, checked);
                      }}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                          event.preventDefault();
                          onChange(!value);
                          onChangeValue(objData, !value);
                        }
                      }}
                    />
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      fontWeight="bold"
                      fontSize="14px"
                      sx={{ marginLeft: 2 }} // Space between switch and label
                      className={disabled ? 'switch-label-disabled' : ''}>
                      Yes
                    </Typography>
                  </Box>
                }
              />
            </>
          )}
        />
      </Box>
    </Box>
  );
};

export default SwitchToggle;
